import { ModifierSetDto, ModifierSetTypeDto } from "services/modifierSets/restModels";

import { MODIFIER_SET_TYPE_LABELS } from "features/ModifierSets/constants";

const modifiersCountText = (count: number) => {
    const lastTwo = count % 100;
    const last = count % 10;

    if (lastTwo > 10 && lastTwo < 20) return `${count} вариантов`;
    if (last === 1) return `${count} вариант`;
    if (last > 1 && last < 5) return `${count} варианта`;

    return `${count} вариантов`;
};

/*
* Ограничения набора словами. Ноль в лимитах гостевое меню трактует как «границы нет»
* (см. modifiersModal), поэтому нули не показываем как «от 0 до 0».
* */
const limitsText = (modifierSet: ModifierSetDto): string => {
    if (modifierSet.type === ModifierSetTypeDto.ChooseOne) {
        return modifierSet.isRequired ? "обязательный" : "необязательный";
    }

    const min = modifierSet.minCountTotalChosen;
    const max = modifierSet.maxCountTotalChosen;

    if (min > 0 && max > 0) return `от ${min} до ${max}`;
    if (min > 0) return `не менее ${min}`;
    if (max > 0) return `не более ${max}`;

    return "без ограничений";
};

// Подпись набора в списках: тип, ограничения и количество вариантов.
export const modifierSetSummary = (modifierSet: ModifierSetDto): string =>
    [
        MODIFIER_SET_TYPE_LABELS[modifierSet.type],
        limitsText(modifierSet),
        modifiersCountText(modifierSet.modifiers.length),
    ].join(" · ");
